/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};

  // 检查用户是否有指定权限
  const hasPermission = (permission: string) => {
    // TODO: 这里应该从用户的权限列表中检查
    // return currentUser?.permissions?.includes(permission) || false;
    return true; // 临时实现
  };

  // 检查用户是否有指定角色
  const hasRole = (role: string) => {
    // TODO: 这里应该从用户的角色列表中检查
    // return currentUser?.roles?.some(r => r.code === role) || false;
    return true; // 临时实现
  };

  return {
    // 基础权限
    canAdmin: hasRole('admin'),
    canMerchant: hasRole('merchant') || hasRole('admin'),

    // 系统管理权限
    canSystemMenu: hasPermission('system:menu') || hasRole('admin'),
    canSystemRole: hasPermission('system:role') || hasRole('admin'),
    canSystemUser: hasPermission('system:user') || hasRole('admin'),

    // 商家管理权限
    canMerchantView: hasPermission('merchant:view') || hasRole('merchant') || hasRole('admin'),
    canMerchantCreate: hasPermission('merchant:create') || hasRole('admin'),
    canMerchantEdit: hasPermission('merchant:edit') || hasRole('admin'),
    canMerchantDelete: hasPermission('merchant:delete') || hasRole('admin'),

    // 审核权限
    canMerchantAudit: hasPermission('merchant:audit') || hasRole('admin'),
  };
}
